import React from 'react';

const CodeSamples = () => {
  const samples = [
    {
      title: 'Reusable Component Example',
      description: 'Demonstrates clean component architecture with TypeScript, proper prop typing, and composition patterns for maximum reusability across projects.'
    },
    {
      title: 'State Management Pattern (Redux/Zustand)',
      description: 'Shows scalable state management with normalized data structures, middleware patterns, and optimized selectors for complex applications.'
    },
    {
      title: 'Performance Optimization Pattern',
      description: 'Illustrates React.memo, useMemo, code splitting, and lazy loading techniques that reduce bundle size and improve runtime performance.'
    },
    {
      title: 'Accessibility (A11y) Example',
      description: 'Implements ARIA attributes, keyboard navigation, screen reader support, and WCAG 2.1 compliance for inclusive user experiences.'
    }
  ];

  return (
    <section id="code-samples" className="code-samples-section">
      <div className="code-samples-container">
        <div className="section-header">
          <h2 className="section-title">Code Samples</h2>
          <p className="section-subtitle">
            Patterns and practices that demonstrate technical depth
          </p>
        </div>

        <div className="code-samples-grid">
          {samples.map((sample, index) => (
            <div key={index} className="code-sample-card">
              <h3 className="code-sample-title">{sample.title}</h3>
              <p className="code-sample-description">{sample.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CodeSamples;

